import React from 'react'
import { useRouter } from 'next/router'

import FormSteps from 'src/components/formSteps'
import { Radio } from 'src/components/forms'
import PageContainer from 'src/components/pageContainer'
import SchedulingInfo from 'src/components/schedulingSteps/schedulingInfo'

import { useServiceScheduleContext, actionTypes } from 'src/context/serviceScheduleContext'
import { useProfessionalContext } from 'src/context/professionalContext'
import Calendar from 'static/icons/calendar-alt.svg'
import User from 'static/icons/user-alt.svg'

import withRootContext from 'context/withRootContextHOC'

import * as S from './styles'
import { flowOptionClickEvent } from '../../../utils/gtag'

const FlowSelectionStep = (props) => {
  const router = useRouter()

  const { context } = props
  const { state: schedulingState, functions: schedulingFunctions, dispatch } = useServiceScheduleContext()
  const { functions } = useProfessionalContext()

  const {
    findPartnerScheduleAndCampaignAviability
  } = schedulingFunctions

  const {
    getProfessionals
  } = functions

  const { scheduleBody, availableDates, availableSlots } = schedulingState

  const selectFlowOption = async (invertSteps) => {
    let newState = {}
    const serviceCategory = window.localStorage.getItem('category')
    if (!invertSteps) {
      await getProfessionals({ context, router })
      flowOptionClickEvent('Profissional', serviceCategory)
    } else if (!availableDates.length || !availableSlots.length) {
      context.showLoader()

      newState = await findPartnerScheduleAndCampaignAviability(
        scheduleBody?.partner_id
      )
      flowOptionClickEvent('Data e horário', serviceCategory)
      context.hideLoader()
    }

    return dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        ...newState,
        invertStep: invertSteps,
        scheduleBody: {
          ...scheduleBody,
          professional_id: '',
          selectDay: scheduleBody?.samePetDate ? scheduleBody.selectDay : undefined,
          selectTime: scheduleBody?.samePetDate ? scheduleBody.selectTime : undefined
        }
      }
    })
  }

  return (
    <PageContainer isSchedulingSteps>
      <FormSteps context={context}>
        <S.AlignWrappers>
          <S.WrapperFormAndCard>
            <S.WrapperContainerAndTitle>
              <S.WrapperTitle>
                <span>Selecione como seguir com o agendamento</span>
              </S.WrapperTitle>
              <S.WrapperElements>

                <S.RadioCard onClick={() => selectFlowOption(true)} hasBorder={schedulingState.invertStep}>
                  <S.IconContainer><Calendar /></S.IconContainer>
                  <label>Data e hora</label>
                  <S.RadioButtonContent>
                    <Radio
                      name='next-step-option'
                      value=''
                      dataTest=''
                      checked={schedulingState.invertStep}
                      id='radio-next-step-data'
                    />
                  </S.RadioButtonContent>
                </S.RadioCard>
                <S.RadioCard onClick={() => selectFlowOption(false)} hasBorder={schedulingState.invertStep === false}>
                  <S.IconContainer><User /></S.IconContainer>
                  <label>Profissional</label>
                  <S.RadioButtonContent>
                    <Radio
                      name='next-step-option'
                      dataTest=''
                      value=''
                      checked={schedulingState.invertStep === false}
                      id='radio-next-step-professional'
                    />
                  </S.RadioButtonContent>
                </S.RadioCard>
              </S.WrapperElements>
            </S.WrapperContainerAndTitle>
            <SchedulingInfo />
          </S.WrapperFormAndCard>
        </S.AlignWrappers>
      </FormSteps>
    </PageContainer>
  )
}

export default withRootContext(FlowSelectionStep)
